/**
 * Custom hook for network status detection
 */
import { useState, useEffect } from 'react';
import { NETWORK_CONSTANTS } from '@/lib/constants/appConstants';

export const useNetworkStatus = () => {
  const [networkSlow, setNetworkSlow] = useState(false);

  useEffect(() => {
    const handleConnectionChange = () => {
      const connection = (navigator as any).connection || 
                        (navigator as any).mozConnection || 
                        (navigator as any).webkitConnection;
      
      if (connection) {
        const slowConnections = NETWORK_CONSTANTS.SLOW_CONNECTION_TYPES;
        setNetworkSlow(slowConnections.includes(connection.effectiveType));
      }
    };

    handleConnectionChange();
    
    if ('connection' in navigator && (navigator as any).connection?.addEventListener) {
      (navigator as any).connection.addEventListener('change', handleConnectionChange);
      
      return () => {
        if ((navigator as any).connection?.removeEventListener) {
          (navigator as any).connection.removeEventListener('change', handleConnectionChange);
        }
      };
    }
  }, []);

  return { networkSlow };
};
